export enum UserTicketActionsEnum {
    QR = 'QR',
    DELETE = 'DELETE',
    REMOVE = 'REMOVE',
    REFUND = 'REFUND',
    BUY_AGAIN = 'BUY_AGAIN',
    PAUSE = 'PAUSE',
    REACTIVATE = 'REACTIVATE',
    RENEW = 'RENEW'
    // QR = {
    //     type: 'QR',
    //     class: 'qr',
    //     title: 'ACTION_SEE_QR_TITLE',
    //     description: 'ACTION_SEE_QR_DESCRIPTION'
    // },
    // DELETE = {
    //     type: 'DELETE',
    //     class: 'delete',
    //     title: 'ACTION_DELETE_TITLE',
    //     description: 'ACTION_DELETE_DESCRIPTION'
    // },
    // REMOVE = {
    //     type: 'REMOVE',
    //     class: 'remove',
    //     title: 'ACTION_REMOVE_TITLE',
    //     description: 'ACTION_REMOVE_DESCRIPTION'
    // },
    // REFUND = {
    //     type: 'REFUND',
    //     class: 'refund',
    //     title: 'ACTION_REFUND_TITLE',
    //     description: 'ACTION_REFUND_DESCRIPTION'
    // },
    // BUY_AGAIN = {
    //     type: 'BUY_AGAIN',
    //     title: 'ACTION_BUY_AGAIN_TITLE',
    //     description: 'ACTION_BUY_AGAIN_DESCRIPTION'
    // },
}
